'use strict';

var _require = require('./Component'),
    CopyToClipboard = _require.CopyToClipboard;

module.exports = CopyToClipboard;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-copy-to-clipboard/lib/index.js
// module id = 270
// module chunks = 0